import { useFormik } from 'formik';
import * as Yup from 'yup';

export function useClientValidation(onSubmit) {
  const initialValues = {
    firstName: '',
    lastName: '',
    rut: '',
    phone: '',
    email: '',
    address: '',
    region: '',
    commune: '',
    isCompany: false,
    companyName: '',
    companyRut: '',
    companyAddress: '',
    companyRegion: '',
    companyComuna: '',
    interests: [], // Categorías de interés del cliente
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      firstName: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      lastName: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      rut: Yup.string()
        .matches(
          /^\d{1,3}\.?\d{1,3}\.?\d{1,3}-[0-9kK]$/,
          'Formato de RUT inválido. Ejemplo: 12.345.678-9 o 12345678-9',
        )
        .notRequired(),
      phone: Yup.string()
        .length(12, 'Debe tener 12 caracteres')
        .matches(
          /^\+56\d{9}$/,
          'Formato de teléfono inválido. Ejemplo: +56912345678',
        )
        .notRequired(),
      email: Yup.string()
        .matches(
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          'Formato de correo electrónico inválido. Ejemplo: nombre@dominio.com',
        )
        .notRequired(),
      address: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      region: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      commune: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      isCompany: Yup.boolean().transform((value) => {
        // Handle checkbox values that come as "on" or arrays
        if (value === 'on' || value === true) return true;
        if (Array.isArray(value) && value.includes('on')) return true;
        if (value === 'off' || value === false) return false;
        return Boolean(value);
      }),
      companyName: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      companyRut: Yup.string()
        .matches(
          /^\d{1,3}\.?\d{1,3}\.?\d{1,3}-[0-9kK]$/,
          'Formato de RUT inválido. Ejemplo: 12.345.678-9 o 12345678-9',
        )
        .notRequired(),
      companyAddress: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      companyRegion: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      companyComuna: Yup.string()
        .min(3, 'Debe tener al menos 3 caracteres')
        .max(255, 'No debe exceder 255 caracteres')
        .notRequired(),
      interests: Yup.array()
        .of(
          Yup.object().shape({
            category: Yup.string().required(),
            subcategories: Yup.array().of(Yup.string()),
          }),
        )
        .notRequired(),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
